<template>
    <div class="boxes">
        <div class="box">
            <div class="box-heading border-bottom" style="position: relative;">
                <h5>私服元宝的消费记录</h5>
                <select v-model="server_id" @change="changeServerId" style="position: absolute;top:-5px;left:180px;width:200px;height: 30px;">
                    <option value="0">请选择服务端</option>

                    <option v-for="server in servers" v-bind:value="server.id" v-text="server.server_name" ></option>
                </select>
            </div>
        </div>
        <div class="threads-items mb-2">
            <ul class="list-group list-group-flush">
                <li
                    class="li-header list-group-item d-md-flex d-block align-items-center justify-content-between cursor-pointer"
                >
                    <div class="align-items-center w-10">
                        <div class="text-blue">
                            所属区服
                        </div>
                    </div>
                    <div class="d-flex align-items-center w-15">
                        <div class="text-blue">
                            私服账户
                        </div>
                    </div>
                    <div class="d-flex align-items-center w-25">
                        <div class="text-gray">
                            物品相关描述
                        </div>
                    </div>
                    <div class="d-flex align-items-center w-20">
                        <div class="text-gray">
                            总消费元宝
                        </div>
                    </div>
                    <div class="align-items-center w-20">
                        <div class="text-gray">
                            元宝统计
                        </div>
                    </div>
                    <div class="d-flex align-items-center w-10">
                        消费时间
                    </div>
                </li>

                <li
                    class="list-group-item d-md-flex d-block align-items-center justify-content-between cursor-pointer"
                    v-for="item in lists.data"
                    :key="item.id"
                >
                    <div class="align-items-center w-10">
                        <div class="text-blue">
                            {{ item.dist }}
                            <span v-if="item.server">（{{ item.server }}）</span>
                        </div>
                    </div>
                    <div class="d-flex align-items-center w-15">
                        <div class="text-blue">
                            {{ item.account }}
                        </div>
                    </div>
                    <div class="d-flex align-items-center w-25">
                        <div class="text-gray">
                            <p>物品名称：</p>
                            <p style="font-size: small;">{{ item.buy_item }}</p>
                            <p>物品单价：{{ item.item_price }}</p>
                            <p>购买数量：{{ item.buy_item_amount }}</p>
                        </div>
                    </div>
                    <div class="d-flex align-items-center w-20">
                        <div class="text-gray">
                            {{item.show_cost_coin}}
                        </div>
                    </div>
                    <div class="d-flex align-items-center w-20">
                        <div class="text-gray" style="font-size: small;">
                            <p>金元宝</p>
                            <p>消费：{{ item.gold_coin_cost }}</p>
                            <p>剩余：{{ item.gold_coin_left }}</p>

                            <p>银元宝</p>
                            <p>消费：{{ item.silver_coin_cost }}</p>
                            <p>剩余：{{ item.silver_coin_left }}</p>
                        </div>
                    </div>
                    <div class="d-flex align-items-center w-10">
                        {{ item.cost_time }}
                    </div>
                </li>
            </ul>
            <paginator :meta="lists" @change="handlePageChanged"></paginator>
        </div>
    </div>
</template>

<script>
    import {
        TimeTransformationDate
    } from '@/utils/CommonUtil.js';
    import Paginator from '$components/paginator';
    export default {
        name: 'sign',
        components: {
            Paginator
        },
        data() {
            return {
                user_info: {},
                lists: {},
                servers: {},
                server_id: 0,
            }
        },
        created() {
            this.user_info = this.$user().user_info;
            
            this.getServers();
        },
        methods: {
            getServers() {
                this.$http.get('asktao/servers')
                .then((res) => {
                    this.servers = res.data;

                    for(let item of this.servers) { //item为list中的对象
                        console.log(item);
                        if(item.is_default == 1){
                            this.server_id = item.id;
                            this.getCostLogs();
                            break;
                        }
                    }

                    if(!this.server_id){
                        this.$message.error('请选择服务端');
                    }
                });
            },
            changeServerId(e){
                this.server_id = e.target.value;
                if(this.server_id){
                    this.getCostLogs(1);
                }
            },
            handlePageChanged (page) {
                this.getCostLogs(page);
            },
            // 获取元宝消费记录
            getCostLogs(page = 1){
                this.$http
                    .get(`asktao/getCostLogs?page=${page}&server_id=${this.server_id}`)
                    .then((res) => {
                        this.lists = res.data;
                    });
            },
            handleChange(page) {
                this.$emit('page-changed', page)
            },
            formatDate(time){
                return TimeTransformationDate(time, true, true, true, true, true);
            }
        }
    }
</script>

<style scoped>
    li.li-header div.align-items-center{
        text-align: center;
    }
</style>